import { render, staticRenderFns } from "./OverlayCpt.vue?vue&type=template&id=2234dc18&scoped=true&"
import script from "./OverlayCpt.vue?vue&type=script&lang=ts&"
export * from "./OverlayCpt.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayCpt.vue?vue&type=style&index=0&id=2234dc18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234dc18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VOverlay,VProgressCircular,VRow})
